import { GET_LEADER_BOARD } from "../actions/types"

const initialState = {
    leaderBoard: null
};

export const leaderBoardReducer =  (state = initialState, { type, payload }) => {
    switch (type) {

    case GET_LEADER_BOARD:
        let count = 0;
        let withIdArray = payload.map(element => element = {...element, id: count++});
        return {leaderBoard: withIdArray};

    default:
        return state
    }
}

export default leaderBoardReducer;